import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { Location, NgTemplateOutlet } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
  ApplicationTypes,  
  AbnComponentValue,
  AcnComponentValue,
  Address2ComponentValue,
  AggregatorSearchComponentValue,
  AppCalculator,
  ApplicationApplicant,
  AzureStorageDocument,
  UploadedDocumentRef,
  Base64File,
  BrokerOfUser,
  BusinessNumberSearchValue,
  BusinessOverdraftApplication,
  BusinessOverdraftSummary,
  BusinessSearchResultValue,
  BusinessSearchValue,
  CheckActiveOverdraftAccountDetails,
  DirectorValue,
  DocumentTag, EntityTypePartnershipOption,
  EntityTypeTrustOption,
  EntityTypeValue, EntityTypes,
  GeoLocation,
  GetSalesforceContactSameAccountFunc,
  GetUserSameCompanyFunc,
  GuarantorValue,
  GuarantorKybSelectionsEvent,
  IndividualGuarantor,
  LoanPurposeValue,
  LoanTermType,
  LoanTermValue,
  LoanTermValueOptions,
  MIN_LOAN_AMOUNT_BUSINESS_LOAN_AND_OVERDRAFT,
  PROPERTY_SECURITY_ACKNOWLEDGEMENT_THRESHOLD,
  MemberValue,
  NotNullable,
  OriginatorBusiness,
  OverdraftPaymentBreakupDialogData,
  PartnerValue,
  PaymentFrequencyValue,
  PaymentFrequencyValueOptions,
  PlacesDetailsFn,
  PlacesSearchResultFn,
  PrimaryIndustrySelectionValue,
  RatecardDetails,
  ReferenceValue,
  SalesforceContactSameAccountSelectionValue,
  SaveApplicationPricingDetailsData,
  SecondaryIndustrySelectionValue,
  SubdivisionIndustrySelectionValue,
  SelectContactValue,
  SliderComponentValue,
  SoleTraderValue,
  TermRateForBusinessOverdraft,
  TrusteeValue,
  UpdateApplicationData,
  WizardSubmitData,
  UploadAzureFiles,
  RequiredTrustDeed,
  UploadAzureFilesValue,
  UploadFileValue,
  User,
  UserSameCompanySelectionValue,
  UserSelectionValue,
  YesNoValue,
  booleanToYesNo,
  calculateBusinessOverdraftFees,
  constants,
  defaultDocuments,
  filesToBase64Files,
  getFileTags,
  isExternalUser,
  maxLoanForBusinessOverdraft,
  patchAcn,
  toDraftSimplifiedApplication,
  GetIndustryDivisionsFn,
  GetIndustryGroupsByDivisionCodeFn,
  GetIndustryClassesByGroupCodeFn,
  KybRefreshFn,
  KybResultFn,
  KybSetManualModeFn,
  KybInitiateCorporatePartyFn,
  KybResult,
  kybHasOwnKeyPeople,
  KybKeyPeopleValue,
  KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
  IndividualDetailsListValue,
  BORROWING_ENTITY_LOCKED_HINT,
  ApplicationCommercialEntityWrite
} from '@portal-workspace/grow-shared-library';
import {
  AbnComponent,
  AcnComponent,
  AggregatorSearchComponent,
  AggregatorSearchFn,
  AnnualRevenueComponent,
  AnnualRevenueValue,
  ApplicationDialogService,
  ApplicationHeaderSegmentComponent,
  ApplicationStepper2Component,
  BusinessNumberSearchComponent,
  BusinessNumberSearchFn,
  BusinessOverdraftSummaryComponent,
  BusinessSearchComponent,
  BusinessSearchFn,
  CurrencyInputComponent,
  CustomAddressComponent,
  DirectorComponent,
  DisableControlDirective,
  EntityTypeComponent,
  GuarantorComponent,
  GuarantorComponentEvent,
  LoanPurposeSelectionComponent,
  MemberComponent,
  MessageBoxComponent,
  MobileComponent,
  PartnerComponent,
  PaymentFrequencySelectionComponent,
  PortalHotToastService,
  previousBusinessNotPrimaryValidator,
  PrimaryIndustrySelectionComponent,
  ReferenceComponent,
  SalesforceContactSameAccountSelectionComponent,
  SecondaryIndustrySelectionComponent,
  SoleTraderComponent,
  TrustDeedUploadComponent,
  TrusteeComponent,
  UploadFileComponent,
  UploadFilesMultiTagsComponent,
  UploadedFilesListComponent,
  UploadedFilesListComponentEvent,
  UserSameCompanySelectionComponent,
  UserSelectionComponent,
  YesNoComponent,
  applicantsThatAreGuarantor,
  applicationToAbn,
  applicationToAcn,
  applicationToAdditionalBrokerCorrespondent,
  applicationToAdditionalCommission,
  applicationToAdverseOnFile,
  applicationToApplicants,
  applicationToApplicationNotes,
  applicationToBrokerContact,
  applicationToBrokerFlowDocumentId,
  applicationToBrokerSearchValue,
  applicationToBusinessSearchValue,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  applicationToGstAgeMonths,
  applicationToGstAgeMonthsWithContinuity,
  searchResultToGstAgeMonths,
  searchResultToGstAgeMonthsWithContinuity,
  applicationToGuarantors,
  applicationToHasAdditionalBrokerCorrespondent,
  applicationToIndustrySector,
  applicationToSubdivisionIndustrySector,
  applicationToLegalName,
  applicationToLoanAmount,
  applicationToLoanPurpose,
  applicationToLoanTerms,
  applicationToOrganisationType,
  applicationToPaymentFrequency,
  applicationToPreviousBusiness,
  applicationToTermRenewal,
  applicationToPrimaryAddress,
  applicationToRegisteredBusinessAddress,
  applicationToPrimaryIndustry,
  applicationToPropertyOwner,
  applicationToReferences,
  applicationToRevenue,
  duplicateFileNameValidator,
  formControlErrorKeys,
  formControlErrorMessage,
  fromApplicantToInteflowCommercialEntities,
  fromApplicantToInteflowIndividualsData,
  fromContactToInteflowContacts,
  fromGuarantorToInteflowCommercialEnttities,
  fromGuarantorToInteflowIndividuals,
  fromReferenceToInteflowReferences,
  getUser,
  mergeGuarantorKybSelections,
  individualGarantors,
  collectIndividualIdDocumentUploads,
  tagIndividualIdDocumentFiles,
  noSpaceValidator,
  requiredAllowEmptyValidator,
  setStepper2StepConfig,
  setupUntilDestroy,
  toApiAddress,
  toInteflowEntityTypes,
  toInteflowLegalName,
  SubdivisionIndustrySelectionComponent,
  KybKeyPeopleComponent,
  KybStatusComponent,
  IndividualDetailsListComponent,
  consentAcknowledgementIndividuals,
  mergeSavedIndividualsIntoInteflowIndividuals,
  savedIndividualsToPrimaryContact,
  savedIndividualsToContacts
} from '@portal-workspace/grow-ui-library';
import { MarkDirective } from '@portal-workspace/grow-ui-library/mark';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import { catchError, from, lastValueFrom, of, Observable, Subscription } from 'rxjs';
import { filter, map, switchMap, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminService } from '../../service/admin.service';
import {
  ApplicationService,
} from '../../service/application.service';
import { AuthService } from '../../service/auth.service';
import { LocalApplicationsDbService } from "../../service/local-applications-db.service";
import {
  navigationUrlForApplicationsWithQueryParams,
  navigationUrlForBusinessOverdraftWithQueryParams,
  navigationUrlForNewApplication
} from '../../service/navigation-urls';
import { RedbookService } from '../../service/redbook.service';
import { DigitalIdService } from '../../service/digital-id.service';
import { IndustryService } from '../../service/industry.service';
// NOTE: Page to land when you are in DRAFT (new unsubmitted) business overdraft application
@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    templateUrl: './business-overdraft.page.html',
    styleUrls: ['./business-overdraft.page.scss'],
    standalone: true,
    imports: [
      ApplicationStepper2Component,
      DisableControlDirective,
      CdkStepperModule,
      NgTemplateOutlet,
      FormsModule,
      ReactiveFormsModule,
      BusinessSearchComponent,
      MarkDirective,
      MatCheckboxModule,
      MatTooltipModule,
      UserSelectionComponent,
      AggregatorSearchComponent,
      PaymentFrequencySelectionComponent,
      YesNoComponent,
      CurrencyInputComponent,
      EntityTypeComponent,
      AbnComponent,
      AcnComponent,
      AnnualRevenueComponent,
      PrimaryIndustrySelectionComponent,
      SecondaryIndustrySelectionComponent,
      CustomAddressComponent,
      MobileComponent,
      ApplicationHeaderSegmentComponent,
      TrusteeComponent,
      SoleTraderComponent,
      PartnerComponent,
      DirectorComponent,
      KybKeyPeopleComponent,
      KybStatusComponent,
      IndividualDetailsListComponent,
      MemberComponent,
      GuarantorComponent,
      MatFormFieldModule,
      MatInputModule,
      ReferenceComponent,
      MessageBoxComponent,
      TrustDeedUploadComponent,
      UploadedFilesListComponent,
      UploadFileComponent,
      UploadFilesMultiTagsComponent,
      BusinessOverdraftSummaryComponent,
      BusinessNumberSearchComponent,
      UserSameCompanySelectionComponent,
      SalesforceContactSameAccountSelectionComponent,
      LoanPurposeSelectionComponent,
      SubdivisionIndustrySelectionComponent
    ],
})
export class BusinessOverdraftPage implements OnInit {

  @HostListener( 'window: popstate', ['$event'])
  async onPopState(event: Event): Promise<void> {
    event.preventDefault();
    await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
  }


  @ViewChild('uploadFilesMultiTagsComponent') uploadFilesMultiTagsComponent!: UploadFilesMultiTagsComponent;
  @ViewChild(LoanPurposeSelectionComponent) loanPurposeComponent!: LoanPurposeSelectionComponent;
  businessSearchPlaceholder: string = "Enter name or ABN…"

  getIndustryDivisionsFn!: GetIndustryDivisionsFn;
  placesSearchResultFn!: PlacesSearchResultFn;
  placesDetailsFn!: PlacesDetailsFn;
  getIndustryGroupsByDivisionCodeFn!: GetIndustryGroupsByDivisionCodeFn;
  getIndustryClassesByGroupCodeFn!: GetIndustryClassesByGroupCodeFn;
  subscriptions: Subscription[] = [];
  existingApplication: BusinessOverdraftApplication | null = null; // will exists if there is a draft
  existingApplicationBureauReport: BusinessOverdraftApplication['CompanyDetails'] | null = null;
  rateCard: RatecardDetails | null = null;
  isDisable = true
  hasActiveOverdraftAccount: boolean = false;
  activeAccountDetails: CheckActiveOverdraftAccountDetails | null = null;
  limitIncreaseDisabled: boolean = false;
  limitDecreaseDisabled: boolean = false;
  renewalDisabled: boolean = false;
  // global:
  ip: string = '';
  geoLocation: GeoLocation = {};
  user: User = getUser()!;
  isExternalUser : boolean = isExternalUser(this.user);
  otherUsersObservable?: Observable<NotNullable<UserSelectionValue>[]>;
  brokerOfUser: BrokerOfUser | null = null;
  acceptedQuotation = false;
  brokerApplicationId: string | null = null;
  applicationId: number | null = null;

  // ADO-1295: the borrowing entity (and previous business) lock once the broker moves off the
  // application step, so the company check and key-people selections stay anchored to the chosen
  // entity. An application id exists only after that step has been saved, which also covers a
  // reopened draft.
  get borrowingEntityLocked(): boolean {
    return !!this.applicationId;
  }

  get step1BusinessLockedHint(): string | null {
    return this.borrowingEntityLocked ? BORROWING_ENTITY_LOCKED_HINT : null;
  }

  // global: step 3 onwards
  organisationName: string = 'Not available';
  terms: TermRateForBusinessOverdraft | null = null;          // available after chart popups
  calculator: AppCalculator | null = null;   // available after chart popups

  // after popup confirmation
  businessUseOnly = false;
  selfServiceability = false;
  brokerageDollar?: number;
  interestRate?: number;
  rbaRate?: number;
  docFee?: number;
  brokerage?: number;
  monthlyFacilityFeePercentage?: number;
  earlyTerminationFee?: number;
  earlyTerminationFeePercent?: number;

  queryParams: Params = {};

  errorKeys = formControlErrorKeys;
  errorMessages = formControlErrorMessage;

  defaultDocuments = defaultDocuments;

  getFileTags = getFileTags;

  // STEP 1:
  step1BusinessSearchFn!: BusinessSearchFn;
  step1GetUserSameCompanyFn!: GetUserSameCompanyFunc;
  step1GetSalesforceContactSameAccountFn!: GetSalesforceContactSameAccountFunc;
  step1BrokerSearchFn!: AggregatorSearchFn;
  step1OrgSalesforceId: string | null = null;
  step1NoOtherUsersInCompany= true;
  formControlStep1Broker!: FormControl<AggregatorSearchComponentValue>;
  formGroupStep1!: FormGroup<{
    broker: FormControl<AggregatorSearchComponentValue>,
    business: FormControl<BusinessSearchValue>,
    showCorrespondent: FormControl<boolean | null>,
    correspondent: FormControl<UserSameCompanySelectionValue>,
    previousBusiness: FormControl<BusinessNumberSearchValue>,
    brokerContact:FormControl<SalesforceContactSameAccountSelectionValue>
  }>;
  formControlStep1Business!: FormControl<BusinessSearchValue>;
  formControlStep1ShowCorrespondent!: FormControl<boolean | null>;
  formControlStep1Correspondent!: FormControl<UserSameCompanySelectionValue>;
  formControlStep1BrokerContact!: FormControl<SalesforceContactSameAccountSelectionValue>;
  formControlStep1PreviousBusiness!: FormControl<BusinessNumberSearchValue>;

  /** GST age that treats a cancelled registration as 0, unlike result.GSTAgeMonths. */
  get step1GstAgeMonths(): number {
    const v = this.formControlStep1Business?.value;
    if (!v || v.type !== 'search-result') return 0;
    return searchResultToGstAgeMonths(v.result, 0);
  }

  step2MonthlyRepayment: string = '';
  step2EstimatedDrawdownDate: Moment = moment();
  step2MaxLimit: number = 500000;
  step2MinLimit: number = MIN_LOAN_AMOUNT_BUSINESS_LOAN_AND_OVERDRAFT;
  step2LoanAmountCustomValidators: ValidatorFn[] = [];

  formControlStep2LoanPurpose!: FormControl<LoanPurposeValue | null>;
  formControlStep2LoanTerms!: FormControl<LoanTermValue>;
  formControlStep2PaymentFrequency!: FormControl<PaymentFrequencyValue>;
  formControlStep2PropertyOwner!: FormControl<YesNoValue>;
  formControlStep2AdverseOnFile!: FormControl<YesNoValue>;
  formControlStep2EquifaxDirectorScoreAbove700!: FormControl<YesNoValue>;
  formControlStep2LoanAmount!: FormControl<SliderComponentValue>;
  formControlStep2TermRenewal!: FormControl<YesNoValue>;
  formControlStep2AdditionalCommission!: FormControl<YesNoValue>;
  formGroupStep2!: FormGroup<{
    loanPurpose: FormControl<LoanPurposeValue | null>,
    loanAmount: FormControl<SliderComponentValue>,
    loanTerms: FormControl<LoanTermValue>,
    paymentFrequency: FormControl<PaymentFrequencyValue>,
    propertyOwner: FormControl<YesNoValue>,
    adverseOnFile: FormControl<YesNoValue>,
    equifaxScore: FormControl<YesNoValue>,
    termRenewal: FormControl<YesNoValue>,
    additionalCommission: FormControl<YesNoValue>,
  }>;

  // STEP 3:
  formControlStep3OrganisationType!: FormControl<EntityTypeValue>;
  formControlStep3Abn!: FormControl<AbnComponentValue>;
  formControlStep3Acn!: FormControl<AcnComponentValue>;
  formControlStep3AnnualRevenue!: FormControl<AnnualRevenueValue>;
  formControlStep3PrimaryIndustry!: FormControl<PrimaryIndustrySelectionValue>;
  formControlStep3IndustrySector!: FormControl<SecondaryIndustrySelectionValue>;
  formControlStep3SubdivisionIndustrySector!: FormControl<SubdivisionIndustrySelectionValue>;
  formControlStep3PrimaryBusinessAddress!: FormControl<Address2ComponentValue>;
  formControlStep3RegisteredBusinessAddress!: FormControl<Address2ComponentValue>;
  // The company check the step waits on. Held so step 4 can render its key people without a second
  // read, and so a re-entered step shows the form immediately instead of waiting again.
  step3KybResult: KybResult | null = null;
  step3ManualKyb = false;
  // The stepper builds every step's content up front, so the company check must not begin waiting
  // until this step is actually reached.
  step3Active = false;
  step3KybResultFn!: KybResultFn;
  step3KybRefreshFn!: KybRefreshFn;
  kybSetManualModeFn!: KybSetManualModeFn;

  /**
   * Whether the form is still behind the applicant's company check.
   *
   * A trust or partnership is let straight through: its key people are the trustees/partners typed
   * in on step 4, so this step reads nothing from that run. Those brokers enter both addresses by
   * hand, because the registry prefill arrives with the same result.
   */
  get step3AwaitingKyb(): boolean {
    return !this.step3ManualKyb
      && !this.step3KybResult
      && kybHasOwnKeyPeople(this.step3OnwardsOrganisationType);
  }

  formGroupStep3!: FormGroup<{
    organisationType: FormControl<EntityTypeValue>,
    abn: FormControl<AbnComponentValue>,
    acn: FormControl<AcnComponentValue>,
    annualRevenue: FormControl<AnnualRevenueValue>,
    primaryIndustry: FormControl<PrimaryIndustrySelectionValue>,
    industrySector: FormControl<SecondaryIndustrySelectionValue>,
    subdivisionIndustrySector: FormControl<SubdivisionIndustrySelectionValue>,
    primaryBusinessAddress: FormControl<Address2ComponentValue>,
    registeredBusinessAddress: FormControl<Address2ComponentValue>,
  }>;
  step3PrimaryIndustryDivisionCode: string | null = null;
  step3IndustrySectorGroupCode: string | null = null;

  // STEP 4:
  step4BusinessSearchFn!: BusinessSearchFn;
  step4BusinessNumberSearchFn!: BusinessNumberSearchFn;
  step4KybResultFn!: KybResultFn;
  step4KybInitiateCorporatePartyFn!: KybInitiateCorporatePartyFn;
  step4KybWarnings: string[] = [];
  // As step3Active: the step is built up front, so its waiting panel must not start before it is
  // reached.
  step4Active = false;
  step3OnwardsOrganisationType: EntityTypes | null = null;
  formControlStep4Applicant!: FormControl<ApplicationApplicant>;
  formControlStep4KybKeyPeople!: FormControl<KybKeyPeopleValue | null>;
  formGroupStep4!: FormGroup<{
    applicant: FormControl<ApplicationApplicant>,
    kybKeyPeople: FormControl<KybKeyPeopleValue | null>,
  }>;

  // STEP 5:
  step5CompanySearchFn!: BusinessSearchFn;
  step5BusinessNumberSearchFn!: BusinessNumberSearchFn;
  // Ticks made against an additional guarantor entity's key people. Merged into the Key People
  // payload on save, which is a full sync and would otherwise deselect them.
  step5KybSelections: GuarantorKybSelectionsEvent | null = null;
  step5KybWarnings: string[] = [];
  formControlStep5Guarantors!: FormControl<GuarantorValue>;
  formGroupStep5!: FormGroup<{
    guarantors: FormControl<GuarantorValue>
  }>;

  // STEP 6: individual details review (also where the primary contact is chosen)
  formControlStep6IndividualDetails!: FormControl<IndividualDetailsListValue>;
  formGroupStep6!: FormGroup<{
    individualDetails: FormControl<IndividualDetailsListValue>,
  }>;
  @ViewChild('individualDetailsListComponent') individualDetailsListComponent?: IndividualDetailsListComponent;
  @ViewChild(KybKeyPeopleComponent) kybKeyPeopleComponent?: KybKeyPeopleComponent;
  @ViewChild(GuarantorComponent) guarantorComponent?: GuarantorComponent;

  // STEP 7:
  formControlStep7BrokerflowDocumentId!: FormControl<string | null>;
  formControlStep7References!: FormControl<ReferenceValue>;
  formGroupStep7!: FormGroup<{
    brokerflowDocumentId: FormControl<string | null>,
    references: FormControl<ReferenceValue>,
  }>;

  step9UploadedDocs: AzureStorageDocument[] = [];
  applicationDocuments: AzureStorageDocument[] | null = null;
  step4DeletedIdDocuments: UploadedDocumentRef[] = [];
  step5DeletedIdDocuments: UploadedDocumentRef[] = [];
  step9DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  filesUploadedToAzure: Base64File[] = [];

  // step 8: trust deeds. Derived here rather than inside the step so the stepper can leave the step
  // out entirely when the application needs no deed.
  requiredTrustDeeds: RequiredTrustDeed[] = [];
  step8DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  formControlStep8TrustDeeds!: FormControl<UploadAzureFilesValue>;
  formGroupStep8!: FormGroup<{
    trustDeeds: FormControl<UploadAzureFilesValue>,
  }>;

  // STEP 9:
  formControlStep9OtherSupportingDocuments!: FormControl<UploadAzureFilesValue>;
  formGroupStep9!: FormGroup<{
    otherSupportingDocuments: FormControl<UploadAzureFilesValue>,
  }>;

  // STEP 10:
  formControlStep10ApplicationNotes!: FormControl<string | null>;
  formGroupStep10!: FormGroup<{
    applicationNotes: FormControl<string | null>,
  }>;

  // STEP 11:
  step11Summary!: BusinessOverdraftSummary;
  formGroupStep11!: FormGroup<{}>;
  documentTypes: DocumentTag[] = [];

  applicationType: ApplicationTypes = 'BusinessOverdraft';

  constructor(private formBuilder: FormBuilder,
    private redbookService: RedbookService,
    private route: ActivatedRoute,
    private toastService: PortalHotToastService,
    private applicationDialogService: ApplicationDialogService,
    private localApplicationDbService: LocalApplicationsDbService,
    private adminService: AdminService,
    private router: Router,
    private location: Location,
    private applicationService: ApplicationService,
    private authService: AuthService,
    private digitalIdService: DigitalIdService,
    private industryService: IndustryService) {
    this.placesSearchResultFn = this.authService.getGooglePlacesSearchResultFn;
    this.placesDetailsFn = this.authService.getGooglePlacesDetailsFn;
    this.getIndustryDivisionsFn = this.industryService.getIndustryDivisionsFn;
    this.getIndustryGroupsByDivisionCodeFn = this.industryService.getIndustryGroupsByDivisionCodeFn;
    this.getIndustryClassesByGroupCodeFn = this.industryService.getIndustryClassesByGroupCodeFn;
  }

  async ngOnInit() {
    setupUntilDestroy(this);
    this.queryParams = this.route.snapshot.queryParams ?? {};
    this.existingApplication = (this.route.snapshot.data as any).application;
    this.rateCard = (this.route.snapshot.data as any).ratecard;
    console.log("Resolved [BusinessOverdraft] application", this.existingApplication)
    if (this.existingApplication) {
      if (this.existingApplication.ApplicationType != 'BusinessOverdraft') {
        this.toastService.error(`This application ${this.existingApplication.ApplicationId} is not an Business Overdraft application`, `Invalid application type`);
      }
    }

    this.initStep1();
    this.initStep2();
    this.initStep3();
    this.initStep4();
    this.initStep5();
    this.initStep6();
    this.initStep7();
    this.initStep8();
    this.initStep9();
    this.initStep10();
    this.initStep11();

    this.populate();
    this.step2UpdateMaxLimit();

    // get ip
    const sub1 = this.applicationService.getIpAddress().pipe(
      map(r => {
        if (r.status) {
          this.ip = r.payload;
          console.log('**** ip', this.ip);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub1);

    // get geolocation
    try {
      const geoLocation = await this.applicationService.getGeoLocation();
      if (geoLocation) {
        this.geoLocation = geoLocation;
      }
      console.log('**** geolocation', geoLocation);
    } catch (err) {
      alert(err);
    }

    // get broker of user
    const sub2 = this.applicationService.getBrokerOfUser(this.user.UserId).pipe(
      tap(r => {
        if (r.status) {
          this.brokerOfUser = r.payload;
        }
      })
    ).subscribe();
    this.subscriptions.push(sub2);
  }

  populate() {
    if (this.existingApplication) {
      const previousBusinessValue = applicationToPreviousBusiness(this.existingApplication);
      this.formControlStep1PreviousBusiness.setValue(previousBusinessValue);
      this.formControlStep1Business.setValue(applicationToBusinessSearchValue(this.existingApplication));
      this.formControlStep1ShowCorrespondent.setValue(applicationToHasAdditionalBrokerCorrespondent(this.existingApplication));
      this.formControlStep1Correspondent.setValue(applicationToAdditionalBrokerCorrespondent(this.existingApplication));
      this.brokerApplicationId = this.existingApplication.BrokerAppId;
      this.applicationId = this.existingApplication.ApplicationId;
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.organisationName = applicationToLegalName(this.existingApplication) ?? '';
      const brokerSearchValue = applicationToBrokerSearchValue(this.existingApplication);
      this.formControlStep1Broker.setValue(brokerSearchValue);
      this.step1OrgSalesforceId = brokerSearchValue?.salesforceId ?? null;
      this.formControlStep1BrokerContact.setValue(applicationToBrokerContact(this.existingApplication))


      // 2
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.formControlStep2LoanPurpose.setValue(applicationToLoanPurpose(this.existingApplication));
      this.formControlStep2LoanTerms.setValue(applicationToLoanTerms(this.existingApplication));
      this.formControlStep2LoanAmount.setValue(applicationToLoanAmount(this.existingApplication));
      this.formControlStep2PaymentFrequency.setValue(applicationToPaymentFrequency(this.existingApplication) ??
      PaymentFrequencyValueOptions.find(o => o.type === 'Monthly') ?? null);
      this.formControlStep2PropertyOwner.setValue(applicationToPropertyOwner(this.existingApplication));
      this.formControlStep2AdverseOnFile.setValue(applicationToAdverseOnFile(this.existingApplication));
      this.formControlStep2EquifaxDirectorScoreAbove700.setValue(applicationToEquifaxDirectorScoreMeetsThreshold(this.existingApplication, '>=700'));
      this.formControlStep2TermRenewal.setValue(applicationToTermRenewal(this.existingApplication));
      this.formControlStep2AdditionalCommission.setValue(applicationToAdditionalCommission(this.existingApplication));

      // 3
      this.formControlStep3OrganisationType.setValue(applicationToOrganisationType(this.existingApplication));
      this.formControlStep3Abn.setValue(applicationToAbn(this.existingApplication));
      this.formControlStep3Acn.setValue(applicationToAcn(this.existingApplication));
      this.formControlStep3AnnualRevenue.setValue(applicationToRevenue(this.existingApplication));
      const primaryIndustry = applicationToPrimaryIndustry(this.existingApplication);
      this.step3PrimaryIndustryDivisionCode = primaryIndustry?.code ?? null;
      this.formControlStep3PrimaryIndustry.setValue(primaryIndustry);
      const industrySector = applicationToIndustrySector(this.existingApplication);
      this.step3IndustrySectorGroupCode = industrySector?.code ?? null;
      this.formControlStep3IndustrySector.setValue(industrySector);
      this.formControlStep3SubdivisionIndustrySector.setValue(applicationToSubdivisionIndustrySector(this.existingApplication));
      this.formControlStep3PrimaryBusinessAddress.setValue(applicationToPrimaryAddress(this.existingApplication));
      this.formControlStep3RegisteredBusinessAddress.setValue(applicationToRegisteredBusinessAddress(this.existingApplication));

      // 4
      const applicants = applicationToApplicants(this.existingApplication);
      this.formControlStep4Applicant.setValue(applicants);

      // 5
      this.formControlStep5Guarantors.setValue(applicationToGuarantors(this.existingApplication));

      // 6 is the individual details step - it loads its own rows from ApplicationIndividual

      // 7
      this.formControlStep7BrokerflowDocumentId.setValue(applicationToBrokerFlowDocumentId(this.existingApplication));
      this.formControlStep7References.setValue(applicationToReferences(this.existingApplication));

      // 8-10
      this.formControlStep10ApplicationNotes.setValue(applicationToApplicationNotes(this.existingApplication));
      this.listUploadedDocuments();
      this.refreshRequiredTrustDeeds();
      this.documentTypes = this.existingApplication.DocumentTypes ?? [];

    } else {  // not prepopulating ie. creating new application

      // auto populate originator business if we have one
      const orignatorBusinessId = this.user?.OriginatorBusinessId;
      if (orignatorBusinessId) {
        this.subscriptions.push(this.applicationService.getOriginatorBusinessById(orignatorBusinessId).pipe(
          tap(r => {
            if (r.payload) {
              const originatorBusiness: OriginatorBusiness = r.payload;
              const v: AggregatorSearchComponentValue = {
                abn: originatorBusiness.ABN,
                entityName: originatorBusiness.EntityName,
                salesforceId: originatorBusiness.SalesforceId,
              }
              this.formControlStep1Broker.setValue(v);
            }
          })
        ).subscribe());
      }
      this.documentTypes = this.applicationDefaultDocuments(false);
    }

    // Check for active overdraft account when loading existing application
    if (this.existingApplication) {
      const abn = applicationToAbn(this.existingApplication);
      if (abn) {
        this.checkActiveAccountForAbn(abn);
      }
    }
  }

  checkActiveAccountForAbn(abn: string | null | undefined): void {
    if (!abn || abn.trim() === '') {
      this.hasActiveOverdraftAccount = false;
      this.activeAccountDetails = null;
      this.limitIncreaseDisabled = false;
      this.limitDecreaseDisabled = false;
      this.renewalDisabled = false;
      return;
    }

    this.subscriptions.push(
      this.applicationService.checkActiveOverdraftAccount(abn).pipe(
        tap(response => {
          if (response.status && response.payload) {
            this.activeAccountDetails = response.payload;
            this.hasActiveOverdraftAccount = response.payload.hasActiveAccount === 'active';

            if (this.hasActiveOverdraftAccount) {
              const states = this.calculateOptionDisabledStates();
              this.limitIncreaseDisabled = states.limitIncreaseDisabled;
              this.limitDecreaseDisabled = states.limitDecreaseDisabled;
              this.renewalDisabled = states.renewalDisabled;

              const eligibilityCheck = this.checkIfAllOptionsDisabled();
              if (eligibilityCheck.allDisabled) {
                this.applicationDialogService.openAlertDialog({
                  message: 'Application Not Eligible',
                  subMessage: eligibilityCheck.errorMessage || 'This application is not eligible based on the account details.'
                });
              }
            } else {
              this.limitIncreaseDisabled = false;
              this.limitDecreaseDisabled = false;
              this.renewalDisabled = false;
            }
          } else {
            this.hasActiveOverdraftAccount = false;
            this.activeAccountDetails = null;
            this.limitIncreaseDisabled = false;
            this.limitDecreaseDisabled = false;
            this.renewalDisabled = false;
          }
          this.step2UpdateAdditionalCommissionDisabledState();
          // ETF depends on the active account's current limit / expiry, which arrive
          // async here — recompute so an existing variation application shows the fee
          // on load without waiting for a further form edit.
          this.calculateVariationFees();
        }),
        catchError(err => {
          console.error('Error checking active overdraft account:', err);
          this.hasActiveOverdraftAccount = false;
          this.activeAccountDetails = null;
          this.limitIncreaseDisabled = false;
          this.limitDecreaseDisabled = false;
          this.renewalDisabled = false;
          this.step2UpdateAdditionalCommissionDisabledState();
          return of(null);
        })
      ).subscribe()
    );
  }

  // Disabled when there is no incremental limit being added to the facility:
  //   - Limit Decrease  → no upside to commission
  //   - Renewal where requested limit equals current limit → pure rollover
  // Renewal with an actual limit change is treated as a limit change (enabled).
  private step2UpdateAdditionalCommissionDisabledState(): void {
    if (!this.formControlStep2AdditionalCommission) {
      return;
    }
    const loanPurposeName = this.formControlStep2LoanPurpose?.value?.name;
    let disable = false;
    if (loanPurposeName === 'Limit Decrease') {
      disable = true;
    } else if (loanPurposeName === 'Renewal') {
      const requestedLimit = this.formControlStep2LoanAmount?.value ?? 0;
      const currentLimit = this.activeAccountDetails?.currentLimit ?? requestedLimit;
      disable = requestedLimit === currentLimit;
    }
    if (disable) {
      if (this.formControlStep2AdditionalCommission.enabled) {
        this.formControlStep2AdditionalCommission.setValue(false, { emitEvent: false });
        this.formControlStep2AdditionalCommission.disable({ emitEvent: false });
      }
    } else {
      if (this.formControlStep2AdditionalCommission.disabled) {
        this.formControlStep2AdditionalCommission.enable({ emitEvent: false });
      }
    }
  }

  calculateOptionDisabledStates(): { limitIncreaseDisabled: boolean; limitDecreaseDisabled: boolean; renewalDisabled: boolean } {
    let limitIncreaseDisabled = false;
    let limitDecreaseDisabled = false;
    let renewalDisabled = false;

    if (this.hasActiveOverdraftAccount && this.activeAccountDetails) {
      // Check Limit Increase/Decrease: disabled if less than 6 months since most recent of lastLimitChange or lastRenewalDate
      const lastLimitChange = this.activeAccountDetails.lastLimitChange;
      const lastRenewalDate = this.activeAccountDetails.lastRenewalDate;

      let mostRecentDate: moment.Moment | null = null;
      if (lastLimitChange) {
        mostRecentDate = moment(lastLimitChange);
      }
      if (lastRenewalDate) {
        const renewalMoment = moment(lastRenewalDate);
        if (!mostRecentDate || renewalMoment.isAfter(mostRecentDate)) {
          mostRecentDate = renewalMoment;
        }
      }

      if (mostRecentDate) {
        const sixMonthsAgo = moment().subtract(6, 'months');
        if (mostRecentDate.isAfter(sixMonthsAgo)) {
          limitIncreaseDisabled = true;
          limitDecreaseDisabled = true;
        }
      }

      // Check Renewal: disabled if more than 90 days until expiry
      const accountExpiryDate = this.activeAccountDetails.accountExpiryDate;
      if (accountExpiryDate) {
        const daysUntilExpiry = moment(accountExpiryDate).diff(moment(), 'days');
        if (daysUntilExpiry > 90) {
          renewalDisabled = true;
        }
      }
    }

    return { limitIncreaseDisabled, limitDecreaseDisabled, renewalDisabled };
  }

  checkIfAllOptionsDisabled(): { allDisabled: boolean; errorMessage?: string } {
    if (!this.hasActiveOverdraftAccount || !this.activeAccountDetails) {
      return { allDisabled: false };
    }

    const states = this.calculateOptionDisabledStates();
    const allDisabled = states.limitIncreaseDisabled && states.limitDecreaseDisabled && states.renewalDisabled;

    if (allDisabled) {
      return {
        allDisabled: true,
        errorMessage: 'This application is not eligible. Limit changes can only be made if more than 6 months have passed since the last limit change or renewal. Renewal can only be requested if there are 90 days or less remaining until account expiry.'
      };
    }

    return { allDisabled: false };
  }

  initStep1() {
    this.formControlStep1Business = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1Broker = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1PreviousBusiness =  this.formBuilder.control(null, [previousBusinessNotPrimaryValidator(() => this.formControlStep1Business.value)]);
    this.formControlStep1ShowCorrespondent = this.formBuilder.control(false)
    this.formControlStep1Correspondent = this.formBuilder.control(null);
    this.formControlStep1BrokerContact = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep1 = this.formBuilder.group({
      broker: this.formControlStep1Broker,
      business: this.formControlStep1Business,
      showCorrespondent: this.formControlStep1ShowCorrespondent,
      correspondent: this.formControlStep1Correspondent,
      brokerContact:this.formControlStep1BrokerContact,
      previousBusiness: this.formControlStep1PreviousBusiness,
    });

    this.step1BrokerSearchFn = (term)=> {
      return this.applicationService.searchBroker2(term).pipe(map(r => r.payload));
    }

    setStepper2StepConfig(this.formGroupStep1, {
      nextStepClickedFn: async (stepper) => {
        const currentBizValue = this.formControlStep1Business.value;
        const currentResult = currentBizValue?.type === 'search-result' ? currentBizValue.result : undefined;
        const gstAge = searchResultToGstAgeMonths(currentResult, 0);
        const gstThreshold = 36;
        if (currentBizValue?.type !== 'search-result' || gstAge >= gstThreshold) {
          await this.saveApplication(stepper, 1);
          return;
        }
        const gstAgeWithContinuity = this.resolveGstAgeMonthsWithContinuity();
        if (gstAgeWithContinuity < gstThreshold && !await this.confirmGstAgeException()) {
          return;
        }
        await this.saveApplication(stepper, 1);
      },
      previousStepClickedFn: async (stepper) => {
        if(this.applicationId){
          await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
        }else {
          await this.router.navigate(navigationUrlForNewApplication())
        }
      }
    });


    this.step1BusinessSearchFn = this.applicationService.businessSearchFn;
    this.step1GetUserSameCompanyFn = (orgSalesforceId: string) => {
      return this.authService.getOtherUsersInCompanyBySalesforceIdFn(orgSalesforceId).pipe(
        map(r => {
          // exclude this user
          const filteredCorrespndentUserList =  r.filter(u => u.UserId != this.user.UserId);
          this.step1NoOtherUsersInCompany = filteredCorrespndentUserList.length == 0;
          return filteredCorrespndentUserList;
        })
      );
    }
    this.step1GetSalesforceContactSameAccountFn = this.authService.getSalesforceContactSameAccountFn;
    this.subscriptions.push(this.formControlStep1Broker.valueChanges.pipe(
      tap(broker => {
        if (broker) {
          this.step1OrgSalesforceId = broker.salesforceId;
          this.step1GetUserSameCompanyFn(this.step1OrgSalesforceId).pipe().subscribe();
        }
      })
    ).subscribe());
    this.subscriptions.push(this.formControlStep1ShowCorrespondent.valueChanges.pipe(
      tap((r)=> {
        if(!r){
          this.formControlStep1Correspondent.setValue(null)
        }
      })
    ).subscribe())

    this.subscriptions.push(this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r && r.type === 'search-result') { // NOTE: we can deduce only when business is a ASIC/ACN search
          if (r.entityTypeValue) {
            this.formControlStep3OrganisationType.setValue(r.entityTypeValue);
          }
        }
      })
    ).subscribe());

    const sub = this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r) {
          if (r.abn && this.formControlStep3Abn) {
            this.formControlStep3Abn.setValue(r.abn);
          }
          if (r.acn && this.formControlStep3Acn) {
            const acn = patchAcn(r.acn);
            this.formControlStep3Acn.setValue(acn ?? null);
          }
          this.organisationName = toInteflowLegalName(r) ?? '';
        }
      }),
      debounceTime(500),
      distinctUntilChanged((prev, curr) => {
        const prevAbn = prev?.abn;
        const currAbn = curr?.abn;
        return prevAbn === currAbn;
      }),
      tap((r: BusinessSearchValue) => {
        const abn = r?.abn;
        if (abn) {
          this.checkActiveAccountForAbn(abn);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);

    // previousBusiness stays optional: a GST age below the product threshold is a policy exception
    // the user confirms on Next, not a blocking validation error.
    const sub2 = this.formControlStep1Business.valueChanges.subscribe(v => {
      if (v && v.type === 'search-result') { // NOTE only when business is done through ASIC/ABN search
          const GSTAge = searchResultToGstAgeMonths(v.result, 0);
          if (GSTAge >= 36) {
              this.formControlStep1PreviousBusiness.setValue(null);
          }
      } else if (!this.formControlStep1PreviousBusiness.value) {
          this.formControlStep1PreviousBusiness.setValue(null);
      }
      this.formControlStep1PreviousBusiness.updateValueAndValidity({ emitEvent: false });
    })
    this.subscriptions.push(sub2);

    const sub3 = this.formControlStep1PreviousBusiness.valueChanges.pipe(
      filter(v => v != null && !v.abrResult && !!v.abn),
      switchMap(v => this.applicationService.getAbrResultByAbn(v!.abn!).pipe(
        map(abrResult => ({ v, abrResult }))
      ))
    ).subscribe(({ v, abrResult }) => {
      if (abrResult && v) {
        this.formControlStep1PreviousBusiness.setValue({ ...v, abrResult }, { emitEvent: false });
      }
    });
    this.subscriptions.push(sub3);
  }

  private async confirmGstAgeException(): Promise<boolean> {
    const result = await this.applicationDialogService
      .openAbnGstAgeExceptionDialog()
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  initStep2() {

    this.formControlStep2LoanPurpose = this.formBuilder.control<LoanPurposeValue | null>(null, [Validators.required]);
    this.formControlStep2LoanAmount = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2LoanTerms = this.formBuilder.control(LoanTermValueOptions[2], [Validators.required]);
    this.formControlStep2PaymentFrequency = this.formBuilder.control(PaymentFrequencyValueOptions[2], [Validators.required]);
    this.formControlStep2PropertyOwner = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2AdverseOnFile = this.formBuilder.control(false, [Validators.required]);
    this.formControlStep2EquifaxDirectorScoreAbove700 = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2TermRenewal = this.formBuilder.control(false, [Validators.required]);
    this.formControlStep2AdditionalCommission = this.formBuilder.control(false, [Validators.required]);

    this.formGroupStep2 = this.formBuilder.group({
      loanPurpose: this.formControlStep2LoanPurpose,
      loanAmount: this.formControlStep2LoanAmount,
      loanTerms: this.formControlStep2LoanTerms,
      paymentFrequency: this.formControlStep2PaymentFrequency,
      propertyOwner: this.formControlStep2PropertyOwner,
      adverseOnFile: this.formControlStep2AdverseOnFile,
      equifaxScore: this.formControlStep2EquifaxDirectorScoreAbove700,
      termRenewal: this.formControlStep2TermRenewal,
      additionalCommission: this.formControlStep2AdditionalCommission,
    });

    // Keep the early-termination-fee message (and variation brokerage) in sync as the
    // operator edits Step 2. Previously this ran from the getFeeExplanationMessage()
    // template binding, which fired on every change detection cycle and made the
    // calculator log continuously — an effective infinite loop for Business Overdrafts.
    this.subscriptions.push(
      this.formGroupStep2.valueChanges.pipe(
        tap(() => this.calculateVariationFees())
      ).subscribe()
    );

    // Watch for loan purpose changes to auto-set term renewal for "Renewal" option
    // and to update the limit change validator on loan amount
    this.subscriptions.push(
      this.formControlStep2LoanPurpose.valueChanges.pipe(
        tap((loanPurpose: LoanPurposeValue | null) => {
          if (loanPurpose && loanPurpose.name === 'Renewal') {
            // Automatically set term renewal to Yes when loan purpose is Renewal
            this.formControlStep2TermRenewal.setValue(true, { emitEvent: false });
          }
          
          // Update custom validators array based on loan purpose
          if (this.hasActiveOverdraftAccount && this.activeAccountDetails) {
            if (loanPurpose && (loanPurpose.name === 'Limit Increase' || loanPurpose.name === 'Limit Decrease')) {
              // Set the custom validator for limit increase/decrease
              this.step2LoanAmountCustomValidators = [this.limitChangeValidator()];
            } else {
              // Clear the custom validator for other loan purposes
              this.step2LoanAmountCustomValidators = [];
            }
          } else {
            this.step2LoanAmountCustomValidators = [];
          }

          this.step2UpdateAdditionalCommissionDisabledState();
        })
      ).subscribe()
    );

    // Loan amount changes can flip Renewal between "no limit change" (disabled)
    // and "with limit change" (enabled).
    this.subscriptions.push(
      this.formControlStep2LoanAmount.valueChanges.pipe(
        tap(() => this.step2UpdateAdditionalCommissionDisabledState())
      ).subscribe()
    );

    setStepper2StepConfig(this.formGroupStep2, {
      nextStepButtonText:'Calculate Repayments',
      nextStepClickedFn: async stepper => {

         // Add loan purpose validation check              
        // Mark all fields as touched to trigger validation
        this.loanPurposeComponent?.mark();
        
        // Check if the loan purpose component is invalid
        if (this.loanPurposeComponent?.formGroup?.invalid) {
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: 'Please complete all required loan purpose fields'
          });
          return;
        }

        // Keep existing validation logic
          const adverseOnFile = this.formControlStep2AdverseOnFile.value
          if (adverseOnFile) {
            this.applicationDialogService.openAlertDialog({
              message: "Warning",
              subMessage: `Approvals for business overdraft can only be obtained for borrowers without
              prior adverse credit.
              The borrower may still be eligible for a term loan or invoice finance.
              <br/><br/>
              Please contact your sales representative or call us on 1300 001 420.`
            })
          } else {
            if (!await this.confirmPropertySecurityIfRequired()) {
              return;
            }
            await this.step2ShowQuotation(stepper);
          }
      }
    });

    this.subscriptions.push(this.formControlStep1Business.valueChanges.pipe(
      tap(r => {
        this.step2UpdateMaxLimit();
      })
    ).subscribe());

    this.subscriptions.push(this.formControlStep2PropertyOwner.valueChanges.pipe(
      tap(r => {
        this.step2UpdateMaxLimit();
      })
    ).subscribe())



  }

  initStep3() {
    this.formControlStep3OrganisationType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Abn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Acn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3AnnualRevenue = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryIndustry = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3IndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3SubdivisionIndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3RegisteredBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep3 = this.formBuilder.group({
      organisationType: this.formControlStep3OrganisationType,
      abn: this.formControlStep3Abn,
      acn: this.formControlStep3Acn,
      annualRevenue: this.formControlStep3AnnualRevenue,
      primaryIndustry: this.formControlStep3PrimaryIndustry,
      industrySector: this.formControlStep3IndustrySector,
      subdivisionIndustrySector: this.formControlStep3SubdivisionIndustrySector,
      primaryBusinessAddress: this.formControlStep3PrimaryBusinessAddress,
      registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress,
    });
    // Identify the applicant, so they come from step 1's verified business search and are not
    // re-typed here: changing them would invalidate the company check this step waits on.
    this.formControlStep3Abn.disable();
    this.formControlStep3Acn.disable();
    this.step3KybResultFn = this.applicationService.kybResultFn;
    this.step3KybRefreshFn = this.applicationService.kybRefreshFn;
    this.kybSetManualModeFn = this.applicationService.kybSetManualModeFn;
    const subscription = this.formControlStep3OrganisationType.valueChanges.pipe(
      tap((r: EntityTypeValue) => { // org type changed, clear applicant field
        if (r) {
          if (this.step3OnwardsOrganisationType && this.step3OnwardsOrganisationType !== r.type) {
            // the org type changes and is different from prev value
            this.formControlStep4Applicant.setValue(null)
          }
          this.step3OnwardsOrganisationType = r.type;
          if (r.type === 'company') {
            /* Not required to set it again as validation is already set */
          } else {
            this.formControlStep3Acn.setValidators(null);
            this.formControlStep3Acn.updateValueAndValidity();
          }
        }
      })
    ).subscribe();
    this.subscriptions.push(subscription);

    // Subscribe to ABN changes to check for active overdraft account
    this.subscriptions.push(
      this.formControlStep3Abn.valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap((abn: string | null) => {
          if (abn) {
            this.checkActiveAccountForAbn(abn);
          } else {
            this.hasActiveOverdraftAccount = false;
          }
        })
      ).subscribe()
    );

    this.subscriptions.push(this.formControlStep3PrimaryIndustry.valueChanges.pipe(
      tap(r => {
        this.step3PrimaryIndustryDivisionCode = r?.code ?? null;
        this.formControlStep3IndustrySector.setValue(null);
        this.formControlStep3SubdivisionIndustrySector.setValue(null);
      })
    ).subscribe());

    this.subscriptions.push(this.formControlStep3IndustrySector.valueChanges.pipe(
      tap(r => {
        this.step3IndustrySectorGroupCode = r?.code ?? null;
        this.formControlStep3SubdivisionIndustrySector.setValue(null);
      })
    ).subscribe());

    

    setStepper2StepConfig(this.formGroupStep3, {
      stepSelectionEventFn: () => {
        this.step3Active = true;
      },
      // The form is not on screen until the company check lands, so there is nothing to advance to.
      nextStepButtonDisabledFn: () => this.step3AwaitingKyb,
      nextStepClickedFn: async stepper => {
          await this.saveApplication(stepper, 3);
      }
    });


  }

  /**
   * The applicant's company check finished. Prefill both addresses from the registry into their
   * matching fields, leaving anything the broker already saved on a previous visit alone, and keep
   * the result for step 4.
   */
  onStep3KybResolved(result: KybResult) {
    this.step3KybResult = result;
    const primaryEntity = result.entities.find(entity => entity.isPrimary);
    this.step3ManualKyb = primaryEntity?.mode === 'MANUAL';
    const addresses = primaryEntity?.addresses ?? null;
    // Tested on the address line rather than the object: a saved entity with an empty address still
    // hydrates into a fully-shaped value, which reads as answered while showing the broker nothing.
    if (addresses?.registeredOffice && !this.formControlStep3RegisteredBusinessAddress.value?.address) {
      this.formControlStep3RegisteredBusinessAddress.setValue(addresses.registeredOffice);
    }
    if (addresses?.principalPlaceOfBusiness && !this.formControlStep3PrimaryBusinessAddress.value?.address) {
      this.formControlStep3PrimaryBusinessAddress.setValue(addresses.principalPlaceOfBusiness);
    }
  }

  onStep3ManualKyb(): void {
    if (this.applicationId == null) return;
    this.kybSetManualModeFn(this.applicationId).subscribe({
      next: result => this.onStep3KybResolved(result),
      error: () => undefined,
    });
  }

  initStep4() {
    // Step 4 is now the Key People (KYB) summary screen; the legacy applicant control is retained
    // (null, unvalidated) so the existing null-safe save path keeps compiling. Detailed individual
    // capture is a separate follow-up ticket.
    this.step4BusinessSearchFn = this.applicationService.businessSearchFn;
    this.step4BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.step4KybResultFn = this.applicationService.kybResultFn;
    this.step4KybInitiateCorporatePartyFn = this.applicationService.kybInitiateCorporatePartyFn;
    this.formControlStep4Applicant = this.formBuilder.control(null);
    this.formControlStep4KybKeyPeople = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep4 = this.formBuilder.group({
      applicant: this.formControlStep4Applicant,
      kybKeyPeople: this.formControlStep4KybKeyPeople,
    });

    setStepper2StepConfig(this.formGroupStep4, {
      stepSelectionEventFn: () => {
        this.step4Active = true;
      },
      nextStepValidationMessage: KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
      nextStepClickedFn: async stepper => {
        if (!await this.confirmStep4KybWarnings()) {
          return;
        }
        await this.saveApplication(stepper, 4);
      }
    });

  }

  private async confirmPropertySecurityIfRequired(): Promise<boolean> {
    const loanAmount = this.formControlStep2LoanAmount.value ?? 0;
    if (loanAmount <= PROPERTY_SECURITY_ACKNOWLEDGEMENT_THRESHOLD) {
      return true;
    }
    const result = await this.applicationDialogService
      .openPropertySecurityAcknowledgementDialog()
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  // KYB warnings are advisory, so they are raised here (on Next) rather than inline on the step;
  // continuing is allowed once the user confirms.
  private async confirmStep4KybWarnings(): Promise<boolean> {
    if (!this.step4KybWarnings.length) {
      return true;
    }
    const result = await this.applicationDialogService
      .openKybWarningsConfirmationDialog(this.step4KybWarnings)
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }


  initStep5() {
    this.step5CompanySearchFn = this.applicationService.businessSearchFn;
    this.step5BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.formControlStep5Guarantors = this.formBuilder.control(null, [requiredAllowEmptyValidator]);
    this.formGroupStep5 = this.formBuilder.group({
      guarantors: this.formControlStep5Guarantors,
    });

    // No "at least one guarantor" rule: the required guarantors are captured on Key People, and
    // this step only collects the additional ones the company check did not return.

    setStepper2StepConfig(this.formGroupStep5, {
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 5);
      }
    });
  }

  // individual details review, including the primary contact selection
  initStep6() {
    this.formControlStep6IndividualDetails = this.formBuilder.control(null);
    this.formGroupStep6 = this.formBuilder.group({
      individualDetails: this.formControlStep6IndividualDetails,
    });
    setStepper2StepConfig(this.formGroupStep6, {
      stepSelectionEventFn: e => {
        // re-read from the DB every time the step is entered - the KYB key people and guarantor
        // steps may have added or changed individuals in between. Wait on the previous step's
        // draft save first, otherwise this read races the write that creates those rows and a
        // guarantor added on the step before wouldn't show up until the step is re-entered.
        this.individualDetailsListComponent?.reload(this.pendingDraftSave);
      },
      previousStepClickedFn: async stepper => {
        // flush pending edits so navigating back doesn't lose them
        await this.individualDetailsListComponent?.flushChanges();
        stepper.previous();
      },
      nextStepClickedFn: async stepper => {
        // persists through /save-application-parties; deliberately NOT updateDraftInBg - the
        // legacy Individuals payload rebuilt from earlier step values would overwrite the edits
        // that were just saved on this step. mapToInteflowData re-applies them on later saves.
        const flushed = await this.individualDetailsListComponent?.flushChanges() ?? true;
        if (flushed) {
          stepper.next();
        }
      },
    });
  }

  initStep7() {
    this.formControlStep7BrokerflowDocumentId = this.formBuilder.control(null);
    this.formControlStep7References = this.formBuilder.control([], [requiredAllowEmptyValidator]);
    this.formGroupStep7 = this.formBuilder.group({
      brokerflowDocumentId: this.formControlStep7BrokerflowDocumentId,
      references: this.formControlStep7References,
    });

    setStepper2StepConfig(this.formGroupStep7, {
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 7);
      }
    });
  }

  // trust deeds
  initStep8() {
    this.formControlStep8TrustDeeds = this.formBuilder.control(null);
    this.formGroupStep8 = this.formBuilder.group({
      trustDeeds: this.formControlStep8TrustDeeds,
    });
    setStepper2StepConfig(this.formGroupStep8, {
      nextStepButtonText: 'Next',
      // Uploading is optional, so the step never blocks Next; a deed not supplied here stays a
      // required document on the Documents tab after submission.
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 8);
      },
    });
  }

  /**
   * Re-derive which entities need a deed. Called as the parties settle, since a trust added at the
   * guarantor step changes the answer.
   */
  refreshRequiredTrustDeeds() {
    if (!this.applicationId) {
      return;
    }
    this.subscriptions.push(
      this.applicationService.requiredTrustDeedsFn(this.applicationId).subscribe({
        next: deeds => this.requiredTrustDeeds = deeds,
        // Leaves the step hidden; the deeds are still collected as conditions after submission.
        error: () => this.requiredTrustDeeds = [],
      }),
    );
  }

  onStep8DeleteUploadedDoc(deletedFile: AzureStorageDocument) {
    this.step8DeletedUploadedDocs = [...this.step8DeletedUploadedDocs, deletedFile];
    this.step9UploadedDocs = this.step9UploadedDocs.filter(doc => doc.name !== deletedFile.name);
  }

  initStep9() {
    this.formControlStep9OtherSupportingDocuments = this.formBuilder.control(null,[duplicateFileNameValidator()]);
    this.formGroupStep9 = this.formBuilder.group({
      otherSupportingDocuments: this.formControlStep9OtherSupportingDocuments
    });

    setStepper2StepConfig(this.formGroupStep9, {
      nextStepButtonText:'Next',
      stepSelectionEventFn: e => {
        this.documentTypes = this.applicationDefaultDocuments(true);
      },
      nextStepClickedFn: async stepper => {
        const isMissingTagsCheck = this.formGroupStep9.value.otherSupportingDocuments?.filter(file => file.tags && file.tags.length === 0) ;
        if(isMissingTagsCheck?.length){
          const fileNames = isMissingTagsCheck.map(file => file.name).join(', ');
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: `The following files are missing tags: ${fileNames}`
          });

        }else {
          await this.saveApplication(stepper, 9);
        }
      }
    });
  }

  initStep10() {
    this.formControlStep10ApplicationNotes = this.formBuilder.control(null, [Validators.required, noSpaceValidator()]);
    this.formGroupStep10 = this.formBuilder.group({
      applicationNotes: this.formControlStep10ApplicationNotes,
    });

    setStepper2StepConfig(this.formGroupStep10, {
      nextStepButtonText:'Next to Review',
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 10);
      }
    });
  }

  initStep11() {

    this.formGroupStep11 = this.formBuilder.group({});
    setStepper2StepConfig(this.formGroupStep11, {
      stepSelectionEventFn: e => {
           

          this.step11Summary = {
            broker: this.formControlStep1Broker.value,
            loanAmount: this.formControlStep2LoanAmount.value!,
            // loanPurpose: 'Cash Flow',
            references: this.formControlStep7References.value,
            loanPurpose: this.formControlStep2LoanPurpose.value,
            monthlyRepayment: this.step2MonthlyRepayment,
            estimatedDrawDownDate: this.step2EstimatedDrawdownDate,
            applicationId: String(this.applicationId),
            organisation: this.formControlStep1Business.value,
            organisationType: this.formControlStep3OrganisationType.value,
            addtionalBrokerCorrespondent: this.formControlStep1Correspondent.value,
            abn: this.formControlStep3Abn.value!,
            acn: this.formControlStep3Acn.value!,
            annualRevenue: this.formControlStep3AnnualRevenue.value!,
            primaryIndustry: this.formControlStep3PrimaryIndustry.value,
            industrySector: this.formControlStep3IndustrySector.value,
            subdivisionIndustrySector: this.formControlStep3SubdivisionIndustrySector.value,
            primaryBusinessAddress: this.formControlStep3PrimaryBusinessAddress.value,
            registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress.value,
            loanTerms: this.formControlStep2LoanTerms.value,
            equifaxScoreAboveThreshold: this.formControlStep2EquifaxDirectorScoreAbove700.value,
            adverseOnFile: this.formControlStep2AdverseOnFile.value,
            propertyOwner: this.formControlStep2PropertyOwner.value,
            additionalCommission: this.formControlStep2AdditionalCommission.value,
            brokerflowDocumentId: this.formControlStep7BrokerflowDocumentId.value!,
            paymentFrequency: this.formControlStep2PaymentFrequency.value,
            applicants: this.formControlStep4Applicant.value ?? [],

            guarantors: this.formControlStep5Guarantors.value,

            primaryContact: savedIndividualsToPrimaryContact(this.formControlStep6IndividualDetails.value?.individuals)!,
            contacts: savedIndividualsToContacts(this.formControlStep6IndividualDetails.value?.individuals),
            applicationNotes: this.formControlStep10ApplicationNotes.value!,
            directorScore: false, // 500-550 director score question removed; field kept for payload compatibility
            termRenewal: this.formControlStep2TermRenewal.value!,
            brokerContact:this.formControlStep1BrokerContact.value!
          };
      },
      nextStepButtonText:'Submit',
      nextStepClickedFn: async stepper => {
        this.finalSubmission(stepper, this.step11Summary!);
      }
    });
  }

  step5GuarantorEvent($event: GuarantorComponentEvent) {
    /// $event.entries
  }

  async finalSubmission(stepper: CdkStepper, summary: BusinessOverdraftSummary) {
    await this.agreeToTermsOfSubmission(stepper);
  }


  async agreeToTermsOfSubmission(stepper: CdkStepper) {
    this.subscriptions.push(consentAcknowledgementIndividuals(
      this.digitalIdService.getApplicationIndividualsFn,
      this.applicationId,
      this.formControlStep6IndividualDetails.value?.individuals,
    ).pipe(
        this.toastService.topMenuLoadingObservable(),
        switchMap(individuals => this.applicationDialogService
          .openBusinessOverdraftApplicationConfirmationDialog(individuals).afterClosed()),
        tap(async (r) => {
          if (r && r.readyForSubmission) {
            this.businessUseOnly = true;
            this.selfServiceability = true;
            await this.sendFinalSubmission(stepper);
          }
      })
    ).subscribe());
  }

  async sendFinalSubmission(stepper: CdkStepper) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData(true);

      // update driver licence doc metadata - as the individualId will be changed
      if (this.applicationId) {
        this.subscriptions.push(
          this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
            (r: AzureStorageDocument[]) => {
              const driverLicenceDocs = r.filter(obj => Object.values(obj?.tags ?? {}).includes('driverslicence'));
              for (const doc of driverLicenceDocs) {
                const individual = (data.parties?.individuals ?? []).find(obj => (doc.metadata?.driverslicencename ?? '') == `${obj.givenName ?? ''} ${obj.surname ?? ''}`);
                if (individual && individual.guid) {
                  this.applicationService.updateDocumentMetadataFn(doc.name, "", {
                    ...doc.metadata,
                    individualid: individual.guid ?? ''
                  }).subscribe()
                }
              }
            }
          )
        )
      }

    this.subscriptions.push(this.applicationService.submitApplication(this.applicationId, data).pipe(
      this.toastService.spinnerObservable(),
      tap(r => {
        if (r && r.status) {
          this.applicationDialogService.openApplicationSubmittedDialog().afterClosed().pipe(
            tap(async r => {
              await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, {reload: true}));
            })
          ).subscribe();
        } else {
          // Handle error response with status 400
          const errorMessage = r?.message || 'Error submitting application';
          this.applicationDialogService.openAlertDialog({
            message: `Error`,
            subMessage: errorMessage
          });
        }
      }),
      catchError(error => {
        // Handle HTTP error response (like 400 Bad Request)
        const errorMessage = error?.error?.message || error?.message || 'Error submitting application';
        this.applicationDialogService.openAlertDialog({
          message: `Error`,
          subMessage: errorMessage
        });
        return of(null);
      })
    ).subscribe({}));
  }
  }

  /**
   * GST age (months) for the tier model. Prefer the live business-search result so a new
   * application prices on the correct tier instead of defaulting to Tier 3; fall back to the
   * saved application, then 0. Uses CompanyDetails.GSTAgeMonths (not the continuity-extended
   * value), matching the Business Loan flow and the calculator's tier-model contract.
   */
  private resolveGstAgeMonths(): number {
    const businessSearchValue: BusinessSearchValue = this.formControlStep1Business.value;
    const searchResult = businessSearchValue?.type === 'search-result' ? businessSearchValue : null;
    return searchResult?.result?.GSTAgeMonths
      ?? (this.existingApplication ? applicationToGstAgeMonths(this.existingApplication) : 0);
  }

  /**
   * Continuity-extended GST age (months) for the tier model's Tier 2/3 assessment. Prefer the
   * live business-search result combined with the selected previous business; fall back to the
   * saved application's persisted continuity value, then 0. Tier 1 (premium) is priced on the
   * non-continuity GSTAgeMonths (see resolveGstAgeMonths).
   */
  private resolveGstAgeMonthsWithContinuity(): number {
    const businessSearchValue: BusinessSearchValue = this.formControlStep1Business.value;
    const searchResult = businessSearchValue?.type === 'search-result' ? businessSearchValue : null;
    if (searchResult?.result) {
      return searchResultToGstAgeMonthsWithContinuity(
        searchResult.result,
        this.formControlStep1PreviousBusiness?.value,
        this.resolveGstAgeMonths(),
      );
    }
    return this.existingApplication ? applicationToGstAgeMonthsWithContinuity(this.existingApplication) : 0;
  }

  calculateEstimation(): OverdraftPaymentBreakupDialogData {
    const date = moment().add(1, 'day');
    const loanTermValue: LoanTermValue = this.formControlStep2LoanTerms.value;
    const loanTermType: LoanTermType | null = loanTermValue?.type ?? null;
    const propertyOwner = this.formControlStep2PropertyOwner.value ?? false;
    const adverseOnFile = this.formControlStep2AdverseOnFile.value ?? false;
    const equifaxDirectorScoreAbove700 = this.formControlStep2EquifaxDirectorScoreAbove700.value ?? false;
    const gstAgeMonths = this.resolveGstAgeMonths();
    const gstAgeMonthsWithContinuity = this.resolveGstAgeMonthsWithContinuity();
    const facilityLimit = this.formControlStep2LoanAmount.value ?? 0;
    const additionalCommission = this.formControlStep2AdditionalCommission.value ?? false;

    const loanPurpose = this.formControlStep2LoanPurpose?.value ?? null;
    const termRenewal = this.formControlStep2TermRenewal.value ?? false;

    const r = calculateBusinessOverdraftFees(date, {
      type: 'BusinessOverdraft',
      loanTermType,
      propertyOwner,
      adverseOnFile,
      equifaxDirectorScoreAbove700,
      gstAgeMonths,
      gstAgeMonthsWithContinuity,
      rateCard: this.rateCard,
      facilityLimit,
      additionalCommission,
      loanPurpose,
      termRenewal,
      activeAccountDetails: this.activeAccountDetails,
    });

    this.calculator = r.calculator;
    this.brokerageDollar = r.term.brokerageDollar;
    this.brokerage = r.term.brokerage;
    this.interestRate = r.term.interestRate;
    this.rbaRate = this.rateCard?.rbaRate;
    this.docFee = r.term.docFee;
    this.terms = r.term;
    this.monthlyFacilityFeePercentage = r.term.monthlyFacilityFeePercentage;
    this.earlyTerminationFee = r.earlyTerminationFee;
    this.earlyTerminationFeePercent = r.earlyTerminationFeePercent;

    return {
      term: r.term,
    };
  }

  /**
   * Custom validator for limit increase/decrease validation.
   * Validates that:
   * - For Limit Increase: requested limit must be greater than current limit
   * - For Limit Decrease: requested limit must be less than current limit
   */
  private limitChangeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.hasActiveOverdraftAccount || !this.activeAccountDetails || !control.value) {
        return null;
      }

      const loanPurpose = this.formControlStep2LoanPurpose?.value;
      if (!loanPurpose) {
        return null;
      }

      const requestedLimit = control.value as number;
      const currentLimit = this.activeAccountDetails.currentLimit ?? 0;

      if (loanPurpose.name === 'Limit Increase') {
        if (requestedLimit <= currentLimit) {
          return {
            limitIncreaseTooLow: {
              currentLimit: currentLimit
            }
          };
        }
      } else if (loanPurpose.name === 'Limit Decrease') {
        if (requestedLimit >= currentLimit) {
          return {
            limitDecreaseTooHigh: {
              currentLimit: currentLimit
            }
          };
        }
      }

      return null;
    };
  }

  /**
   * Recalculates variation fees (brokerage and ETF) from the current form state using
   * the merged `calculateBusinessOverdraftFees` function. Driven reactively from Step 2
   * value changes and the active-account load so the ETF display stays in sync without
   * invoking the calculator from a template-bound getter (which ran every change
   * detection cycle and produced continuous logs).
   */
  private calculateVariationFees(): void {
    if (!this.rateCard) {
      return;
    }
    const loanTermValue: LoanTermValue = this.formControlStep2LoanTerms.value;
    const loanPurpose: LoanPurposeValue | null = this.formControlStep2LoanPurpose.value;
    const termRenewal = this.formControlStep2TermRenewal.value ?? false;
    const date = moment().add(1, 'day');

    const equifaxDirectorScoreAbove700 = this.formControlStep2EquifaxDirectorScoreAbove700.value ?? false;
    const gstAgeMonths = this.resolveGstAgeMonths();
    const gstAgeMonthsWithContinuity = this.resolveGstAgeMonthsWithContinuity();
    const result = calculateBusinessOverdraftFees(date, {
      type: 'BusinessOverdraft',
      loanTermType: loanTermValue?.type ?? null,
      propertyOwner: this.formControlStep2PropertyOwner.value ?? false,
      adverseOnFile: this.formControlStep2AdverseOnFile.value ?? false,
      equifaxDirectorScoreAbove700,
      gstAgeMonths,
      gstAgeMonthsWithContinuity,
      rateCard: this.rateCard,
      facilityLimit: this.formControlStep2LoanAmount.value ?? 0,
      additionalCommission: this.formControlStep2AdditionalCommission.value ?? false,
      loanPurpose,
      termRenewal,
      activeAccountDetails: this.activeAccountDetails,
    });

    this.brokerageDollar = result.term.brokerageDollar;
    this.brokerage = result.term.brokerage;
    this.earlyTerminationFee = result.earlyTerminationFee;
    this.earlyTerminationFeePercent = result.earlyTerminationFeePercent;
  }

  /**
   * Get the fee explanation message based on loan purpose and term renewal settings.
   * Uses the earlyTerminationFee calculated by `calculateBusinessOverdraftFees`.
   */
  getFeeExplanationMessage(): string | null {
    // Pure read of the pre-computed fee. Recalculation is driven reactively from
    // Step 2 value changes / active-account load (see initStep2 + checkActiveAccountForAbn),
    // NOT from this template-bound getter — running the calculator on every change
    // detection cycle spammed console.table and behaved like an infinite loop.
    // Return message only if early termination fee has been calculated and is greater than 0
    if (this.earlyTerminationFee !== undefined && this.earlyTerminationFee > 0) {
      return `Early Termination Fee: $${this.earlyTerminationFee.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
    }
    return null;
  }


  private step5OnwardsApplicantsThatAreGuarantor(): IndividualGuarantor[] {
    const applicant: TrusteeValue | MemberValue | PartnerValue | SoleTraderValue | DirectorValue = this.formControlStep4Applicant.value;
    const guarantors = applicantsThatAreGuarantor(applicant);
    return guarantors;
  }

  private async step2ShowQuotation(stepper: CdkStepper) {

    this.step2EstimatedDrawdownDate = moment().add(1, 'day');

    // if (!this.acceptedQuotation) { // have not accepted quotation yet
    const subscription = this.applicationDialogService.openBusinessOverdraftQuotationDialog({
      loadFn: () => {
        return this.calculateEstimation();
      },
      isQuote: false,
      hideBrokerage: false,
    }).afterClosed()
      .pipe(
        tap(r => {
          if (r && r.acceptedQuotation) {
            this.acceptedQuotation = true;
            this.saveApplication(stepper, 2);
          }
        })
      ).subscribe();
    this.subscriptions.push(subscription);

  }

  private async saveApplication(stepper: CdkStepper, step: number) {
    if (!this.applicationId) { // application was not saved before (new draft)
      const inteflowData = await this.mapToInteflowData();
      console.log('***** save application (new)', this.applicationId, inteflowData);
      this.applicationService.saveApplication(inteflowData).pipe(
        this.toastService.spinnerObservable(),
        tap(r => {
          const applicationId = r.payload.ApplicationId;
          const brokerApplicationId = r.payload.BrokerApplicationId;
          this.brokerApplicationId = brokerApplicationId;
          this.applicationId = applicationId;
          this.syncUrlWithApplicationId();
          const business: BusinessSearchValue = this.formControlStep1Business.value
          if (business) {
            this.organisationName = business.organisationName;
          }
          this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, inteflowData));
          stepper.next();
        }),
        catchError(err => {
          this.applicationDialogService.openAlertDialog({
            message: 'Error',
            subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
          });
          return of(null);
        })
      ).subscribe();
    } else {  // existing draft
      const inteflowData = await this.mapToInteflowData();
      console.log('***** save application draft');
      console.log('**** inteflowdata', inteflowData);
      try {
        await this.updateDraftInBg(step);
        stepper.next();
      } catch (err: any) {
        this.applicationDialogService.openAlertDialog({
          message: 'Error',
          subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
        });
      }
    }
  }

  // Put the new draft's id in the address bar so a refresh reopens it instead of starting a blank
  // application. replaceState rather than router.navigate: 'business-overdraft' and
  // 'business-overdraft/:applicationId' are separate route configs, so navigating would rebuild this
  // component and discard everything the user has entered.
  private syncUrlWithApplicationId() {
    if (!this.applicationId) {
      return;
    }
    const urlTree = navigationUrlForBusinessOverdraftWithQueryParams(this.router, this.applicationId, this.queryParams);
    this.location.replaceState(this.router.serializeUrl(urlTree));
  }

  async uploadFileToAzure(step: number, data: WizardSubmitData) {
    let base64Files: Base64File[] = [];
    let allToBeDeleted: string[] = [];
    let allFiles: File[] = [];
    if (step === 4) {
      allFiles = tagIndividualIdDocumentFiles(
        this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? [],
        data.parties?.individuals ?? [],
        this.step9OtherDocMetadata,
      );
      allToBeDeleted = this.step4DeletedIdDocuments.map(document => document.name);
    } else if (step === 5) { // guarantor ID documents (driver licence / passport) from the individual form
      const uploads = [
        ...collectIndividualIdDocumentUploads(individualGarantors(this.formControlStep5Guarantors.value)),
        ...(this.guarantorComponent?.manualIdDocumentUploads() ?? []),
      ];
      allFiles = tagIndividualIdDocumentFiles(uploads, data.parties?.individuals ?? [], this.step9OtherDocMetadata);
      allToBeDeleted = this.step5DeletedIdDocuments.map(document => document.name);
    } else if (step === 8) { // trust deeds, already tagged with the condition they were dropped into
      const trustDeeds = this.formControlStep8TrustDeeds.value;
      allToBeDeleted = [...this.step8DeletedUploadedDocs].map(file => file.name);
      if (trustDeeds && trustDeeds.length) {
        allFiles = [...trustDeeds];
      }
    } else if (step === 9) { // other supporting doc
      const otherSupportingDocs: UploadFileValue = this.formControlStep9OtherSupportingDocuments.value;
      allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
      if (otherSupportingDocs && otherSupportingDocs.length) {
        allFiles = [...otherSupportingDocs];
      }
    } else {
      return;
    }
    base64Files = [...await filesToBase64Files(allFiles)];
    // double check if any changes with existing files
    // remove file that has been uploaded
    base64Files = base64Files.map(file => {
      file.metadata = file.tags?.includes('driverslicence') ? file.metadata : this.step9OtherDocMetadata
      return file;
    }).filter(f => {
      const fileIdentifiers = this.filesUploadedToAzure.map(m =>
        `${m.name}${m.tags?.join(' ')}${m.metadata?.individualid ?? m.metadata?.driverslicencename ?? ''}`);
      return !fileIdentifiers.includes(
        `${f.name}${f.tags?.join(' ')}${f.metadata?.individualid ?? f.metadata?.driverslicencename ?? ''}`,
      );
    })
    if (!base64Files.length && !allToBeDeleted.length) {
      return;
    }

    if (this.applicationId) {
      await lastValueFrom(
        this.applicationService.uploadApplicationDocumentToAzureStorage(
          this.applicationId,
          [...base64Files],
          allToBeDeleted,
        ),
      );
      this.filesUploadedToAzure = [...this.filesUploadedToAzure, ...base64Files];
      if(step === 4 || step === 5){
        this.listUploadedDocuments()
        if (step === 4) {
          this.step4DeletedIdDocuments = [];
        } else {
          this.step5DeletedIdDocuments = [];
        }
      }else if(step === 8){
        this.listUploadedDocuments()
        this.step8DeletedUploadedDocs = []
        this.formControlStep8TrustDeeds.setValue(null)
      }else if(step === 9){
        this.uploadFilesMultiTagsComponent.files = []
        this.uploadFilesMultiTagsComponent.filesWithTags = []
        this.uploadFilesMultiTagsComponent.formControl.setValue(null)
        this.listUploadedDocuments()
        this.formControlStep9OtherSupportingDocuments.setValue(null)
      }
    }
  }

  async mapToInteflowData(finalSubmission = false, shouldUploadDocs = false) {

    const user  = getUser();
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const correspondentDetails = this.formControlStep1Correspondent.value;
    const o: EntityTypeValue = this.formControlStep3OrganisationType.value;
    const applicationNotes = this.formControlStep10ApplicationNotes.value;
    const brokerflowDocumentId = this.formControlStep7BrokerflowDocumentId.value;
    // primary contact is selected on the individual details step and flagged on the saved rows
    const savedIndividualDetails = this.formControlStep6IndividualDetails.value;
    const contact: SelectContactValue = savedIndividualsToPrimaryContact(savedIndividualDetails?.individuals);
    const broker: AggregatorSearchComponentValue = this.formControlStep1Broker.value;
    const abn = this.formControlStep3Abn.value;
    const acn = this.formControlStep3Acn.value;
    const applicants: ApplicationApplicant = this.formControlStep4Applicant.value;
    const guarantors: GuarantorValue = this.formControlStep5Guarantors.value;
    const refValue: ReferenceValue = this.formControlStep7References.value;
    let previousBusiness: BusinessNumberSearchValue = this.formControlStep1PreviousBusiness.value;

    let brokerSalesforceId = broker!.salesforceId;
    let brokerAbn = broker!.abn;
    let brokerEntityName = broker!.entityName;
    if (user!.BrokerSalesforceId === environment.GrowFinanceGroupSalesforceId) {
      if (broker && broker.salesforceId) {
        brokerSalesforceId = broker.salesforceId;
        brokerAbn = broker.abn;
        brokerEntityName = broker.entityName;
      } else if (this.brokerOfUser && this.brokerOfUser.SalesforceId) {
        brokerSalesforceId = this.brokerOfUser.SalesforceId;
        brokerAbn = this.brokerOfUser.ABN;
        brokerEntityName = this.brokerOfUser.EntityName;
      }
    } else {
      if (this.brokerOfUser && this.brokerOfUser.SalesforceId !== undefined) {
        brokerSalesforceId = this.brokerOfUser.SalesforceId;
        brokerAbn = this.brokerOfUser.ABN;
        brokerEntityName = this.brokerOfUser.EntityName;
      }
    }

    // workout disclosure
    let disclosed = true;
    let introducerGroup = 'ECLIPXCOMMERCIAL';
    if (this.brokerOfUser) {
      if (this.brokerOfUser.Relationship !== 'disclosed') {
        disclosed = false;
        introducerGroup = 'UNDISCLOSED_ECLIPXCOMMERCIAL';
      }
    }

    // work out legalName & entityTYpe
    let legalName = toInteflowLegalName(b) ?? undefined;
    let entityType = o ? toInteflowEntityTypes(o.type) : undefined;

    // work out industries
    const primaryIndustry: PrimaryIndustrySelectionValue = this.formControlStep3PrimaryIndustry.value;
    const secondaryIndustry: SecondaryIndustrySelectionValue = this.formControlStep3IndustrySector.value;
    const subdivisionIndustrySector: SubdivisionIndustrySelectionValue = this.formControlStep3SubdivisionIndustrySector.value;
    const revenue = this.formControlStep3AnnualRevenue.value;
    const address: Address2ComponentValue = this.formControlStep3PrimaryBusinessAddress.value;
    const registeredAddress: Address2ComponentValue = this.formControlStep3RegisteredBusinessAddress.value;


    // entities
    const primaryCommercialEntity: ApplicationCommercialEntityWrite = {
      legalName: legalName ?? undefined,
      entityType: entityType,
      abn: abn ?? undefined,
      // Replaces the ACN delete below: a non-company posts no ACN at all.
      acn: (entityType !== 'PTY' || _.isEmpty(acn)) ? undefined : (acn ?? undefined),
      tradingName: '',
      // Replaces Type: 'Primary'. This is the borrower, so it holds no relationship to another entity.
      isPrimary: true,
      isGuarantor: false,
      relationships: [],
      industry: {
        primaryIndustry: primaryIndustry?.code ?? undefined,
        industrySector: secondaryIndustry?.code ?? undefined,
        // Filed under subdividionClass here, and under industryClass by asset-finance - preserved
        // as-is either way, see doc §17.6.
        subdividionClass: subdivisionIndustrySector?.code ?? undefined,
      },
      revenue: revenue ? Number(revenue) : undefined,
      businessCategory: 'SME ($1m+ Revenue | $0.5m to $5m Capital)',
      principalPlaceOfBusiness: toApiAddress(address),
      registeredBusinessAddress: toApiAddress(registeredAddress),
      abnAgeMonths: (b && b.type === 'search-result' && b?.result) ?
      b.result.ABNAgeMonths :
      this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails.ABNAgeMonths : undefined
    }

    // commercial entities
    const otherCommercialEntities = fromApplicantToInteflowCommercialEntities(applicants);
    const guarantorCommercialEnttities = fromGuarantorToInteflowCommercialEnttities(guarantors);
    const otherCommercialEntity = [
      ...otherCommercialEntities,
      ...guarantorCommercialEnttities,
    ];

    // individuals
    const applicantIndividuals = fromApplicantToInteflowIndividualsData(applicants);
    let guarantorIndividuals = fromGuarantorToInteflowIndividuals(guarantors);

    // for trust application with only corporate trustee, the guarantors are guarantor/signer
    if (entityType === 'TRST' && !applicantIndividuals.length) {
      guarantorIndividuals =  guarantorIndividuals.map(i => {
        return {
          ...i,
          // Was SignerRole: 'GuarantorSigner'. The write shape carries the two facts the string
          // encoded, and these individuals already guarantee - so this is the signing half.
          isSigner: true,
        }
      })
    }

    const otherIndividuals = [
      ...applicantIndividuals,
      ...guarantorIndividuals,
    ];


    // reference
    const references = fromReferenceToInteflowReferences(refValue);
    // pricing details
    const loanTerm: LoanTermValue = this.formControlStep2LoanTerms.value;
    const loanAmount = _.round(this.formControlStep2LoanAmount.value ?? 0, 2);
    const paymentPeriod = 'Monthly';
    const docFeeFinanced = false;
    const docFee = this.docFee;
    const brokerOriginationFee = 0; // no broker origination fee for overdraft
    const propertyOwner = this.formControlStep2PropertyOwner.value;
    const adverseOnFile = this.formControlStep2AdverseOnFile.value;
    const equifaxScore = this.formControlStep2EquifaxDirectorScoreAbove700.value;
    const rate = this.interestRate;
    const rbaRate = this.rbaRate;
    const brokerage = this.brokerage;
    const termRenewal = this.formControlStep2TermRenewal.value;
    const additionalCommission = this.formControlStep2AdditionalCommission.value;
    const monthlyFacilityFeePercentage = this.monthlyFacilityFeePercentage;
    const margin = (rate == undefined || this.rbaRate == undefined) ? undefined : Math.round((rate -this.rbaRate) * 100) / 100; // to prevent from substraction overflow
    const loanPurpose:LoanPurposeValue | null = this.formControlStep2LoanPurpose.value;
    let apiBodyPricingDetails: SaveApplicationPricingDetailsData = {
      LoanTerm: loanTerm?.type ? Number(loanTerm.type) : undefined,
      BrokerOriginationFee: brokerOriginationFee,
      LoanAmount: loanAmount,
      PaymentPeriod: paymentPeriod,
      DocFee: (docFee != null ? Number(docFee) : undefined),
      DocFeeFinanced: booleanToYesNo(docFeeFinanced),
      PropertyOwner: booleanToYesNo(propertyOwner),
      BankStatementSubmitted: 'No' as const,
      AdverseOnFile: booleanToYesNo(adverseOnFile),
      EquifaxDirectorScoreThreshold: equifaxScore ? '>=700' : '<700',
      Rate: rate,
      RbaRate: rbaRate,
      Brokerage: brokerage,
      BrokerageDollar: this.brokerageDollar,
      BrokerageAmount: this.brokerageDollar,
      DirectorScoreRate: 'No', // 500-550 director score question removed; field kept for backend compatibility
      MonthlyFacilityFeePercentage: monthlyFacilityFeePercentage,
      Margin: margin,
      CreditRateAdjustment: 0, // when creating an application, creditRateAdjustment is 0
      LastUpdatedByUser: null,
      TermRenewal: booleanToYesNo(termRenewal),
      AdditionalCommission: booleanToYesNo(additionalCommission),
      LoanPurpose: loanPurpose ?? null,
      EarlyTerminationFee: this.earlyTerminationFee ?? null,
      EarlyTerminationFeePercent: this.earlyTerminationFeePercent ?? null,
    }

    // file tags
    const otherSupportingDocs: UploadAzureFilesValue = this.formControlStep9OtherSupportingDocuments.value;
    const idDocumentUploads = [
      ...collectIndividualIdDocumentUploads(individualGarantors(guarantors)),
      ...(this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? []),
      ...(this.guarantorComponent?.manualIdDocumentUploads() ?? []),
    ];
    const allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
    let allFiles: File[] = tagIndividualIdDocumentFiles(idDocumentUploads, otherIndividuals, this.step9OtherDocMetadata);
    if (otherSupportingDocs && otherSupportingDocs.length) {
      allFiles = [...allFiles, ...otherSupportingDocs];
    }
    allFiles = [...allFiles].filter(file => !allToBeDeleted.includes(file?.name));

    // get doc types
    let uploadedTags = allFiles.reduce((tags: string[], file) => [...tags, ...((file as any).tags ?? [])], []);
    uploadedTags = [...uploadedTags, ...this.step9UploadedDocs.reduce((tags: string[], file: AzureStorageDocument) => [...tags, ...Object.values(file?.tags ?? {})], [])];
    uploadedTags = [...new Set(uploadedTags)];
    console.log('=====uploadedTags: ', uploadedTags);
    for (const tag of uploadedTags) {
      if (!this.documentTypes.map(t => t.value).includes(tag)) {
        const tagObj = (Object.values(constants.documentTypes) as DocumentTag[]).find(obj => obj.value === tag);
        if (tagObj) {
          this.documentTypes.push(tagObj);
        }
      }
    }
    console.log('====updated defaultTags: ', this.documentTypes);

    const companyDetails = (b && b.type === 'search-result' && b?.result) ?
      b.result :
      this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails : undefined;

    const apiBodyReferences = [
      ...references
    ];

    const otherIndividual = [
      ...otherIndividuals
    ];

    const apiBodyCommercialEntities = [
      primaryCommercialEntity,
      ...otherCommercialEntity,
    ];

    const apiBodyContact = fromContactToInteflowContacts(contact);
    const contacts = contact;
    let apiBodyIndividuals =  otherIndividual.map(individual => ({
      ...individual,
      isPrimaryContact:
        individual.givenName === contacts?.firstName &&
        individual.surname === contacts?.lastName &&
        individual.email === contacts?.email,
    }));

    // The Individual Details step saves its edits straight to ApplicationIndividual, but every
    // draft save and the final submission rebuild this payload from the earlier step forms and
    // full-sync the parties - overlay the saved rows or those writes would revert them.
    if (savedIndividualDetails) {
      apiBodyIndividuals = mergeSavedIndividualsIntoInteflowIndividuals(apiBodyIndividuals, savedIndividualDetails.individuals);
    }

    const apiBodyAppInfo = {
      BrokerAppID: this.brokerApplicationId ?? undefined,
      IntroducerGroup: introducerGroup,
      Disclosed: disclosed,
      FinanceType: 'Business Overdraft',
      LoanPurpose: loanPurpose ?? undefined,
      UserId: user!.UserId,
      OriginatorBusinessId: user!.OriginatorBusinessId,
      UserEmail: user!.Email,
      UserFirstName: user!.GivenName,
      UserLastName: user!.FamilyName,
      Notes: applicationNotes ?? undefined,
      BusinessUse: booleanToYesNo(this.businessUseOnly),
      SelfServiceability: booleanToYesNo(this.selfServiceability),
      BrokerflowDocumentID: brokerflowDocumentId ?? undefined,
      BrokerSalesforceID: brokerSalesforceId,
      BrokerAbn: brokerAbn,
      BrokerEntityName: brokerEntityName,
      AssetCategory: '138',
      AssetType: '1',
      ContactId: undefined,
      CustomerId: undefined,
      SalesforceId: undefined,
      StageName: 'Draft',
    };

    // broker contact
    const brokerContact: SalesforceContactSameAccountSelectionValue = this.formControlStep1BrokerContact.value;

    const apiBody: WizardSubmitData = {
      ApplicationType: 'BusinessOverdraft',
      IP: this.ip,
      ApplicantLocation: this.geoLocation,
      UserId: this.applicationService.getApplicationUserId(this.existingApplication,this.user),
      OriginatorBusinessId: this.applicationService.getApplicationOriginatorBusinessId(this.existingApplication,this.user),
      AppInfo: apiBodyAppInfo,
      AssetSpec: undefined,
      Contacts: apiBodyContact,
      // AZ-1475: both party arrays go over the wire in the API shape.
      parties: { individuals: apiBodyIndividuals, commercialEntities: apiBodyCommercialEntities },
      Reference: apiBodyReferences,
      PricingDetails: apiBodyPricingDetails,
      AcceptQuotation: this.acceptedQuotation,
      ApplicationNotes: applicationNotes ?? undefined,
      CompanyDetails: companyDetails ?? undefined,
      AdditionalBrokerCorrespondent: correspondentDetails ?? null,
      BrokerContact: brokerContact,
      // Documents: apiBodyDocuments,
      DocumentTypes: this.documentTypes,
      PreviousBusiness: previousBusiness,
    }
    return apiBody;
  }

  // Steps that re-read parties can wait on the most recent draft save.
  private pendingDraftSave: Promise<void> = Promise.resolve();

  private async updateDraftInBg(step: number, fn?: () => void) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData();
      // KYB "Key People" (step 4) rides on the same update-application2 request as the rest of the
      // parties so both saves share one transaction and cannot race/clobber role flags.
      if ((step === 4 || step === 5) && this.formControlStep4KybKeyPeople.value) {
        data.kybKeyPeople = mergeGuarantorKybSelections(this.formControlStep4KybKeyPeople.value, this.step5KybSelections);
      }
      this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, data));
      const save = this.applicationService.updateApplication(this.applicationId, data).pipe(
        tap(() => {
          if (fn) {
            fn();
          }
          // The entity and guarantor steps are what decide whether a deed is needed, so the trust
          // deed step's visibility is settled once their save has landed.
          if (step === 4 || step === 5 || step === 7) {
            this.refreshRequiredTrustDeeds();
          }
        })
      );
      // The Azure upload and SQL draft update are independent. Run them together, but keep one
      // loading lifecycle and require both acknowledgements before the step can advance.
      const saveOperation = from(Promise.allSettled([
        this.uploadFileToAzure(step, data),
        lastValueFrom(save),
      ])).pipe(
        fn
          ? this.toastService.loadingWithMessage(`Saving, please be patient`)
          : this.toastService.spinnerObservable(),
        map(results => {
          const failed = results.find(result => result.status === 'rejected');
          if (failed?.status === 'rejected') {
            throw failed.reason;
          }
        }),
      );
      const savePromise = lastValueFrom(saveOperation);
      this.pendingDraftSave = savePromise.then(() => undefined, () => undefined);
      await savePromise;
    }
  }

  onIdDocumentDelete(step: 4 | 5, document: UploadedDocumentRef) {
    const deleted = step === 4 ? this.step4DeletedIdDocuments : this.step5DeletedIdDocuments;
    if (!deleted.some(candidate => candidate.name === document.name)) {
      if (step === 4) {
        this.step4DeletedIdDocuments = [...deleted, document];
      } else {
        this.step5DeletedIdDocuments = [...deleted, document];
      }
    }
    this.applicationDocuments = this.applicationDocuments?.filter(candidate => candidate.name !== document.name) ?? null;
    this.step9UploadedDocs = this.step9UploadedDocs.filter(candidate => candidate.name !== document.name);
    this.filesUploadedToAzure = this.filesUploadedToAzure.filter(file => file.name !== document.metadata?.name);
  }

  onStep9DeleteUploadedDoc($event: UploadedFilesListComponentEvent) {
    this.filesUploadedToAzure = this.filesUploadedToAzure
      .filter(file => {
        return !(file.name === $event.deletedFile.metadata?.name);
      });
    this.step9DeletedUploadedDocs = [...$event.deleted];
  }

  private step2UpdateMaxLimit() {
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const GSTAge = (b as BusinessSearchResultValue)?.result?.GSTAgeMonths ?? 0;
    this.step2MaxLimit = maxLoanForBusinessOverdraft(GSTAge, this.formControlStep2PropertyOwner.value);

  }

  get step9OtherDocMetadata() {
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const abn = this.formControlStep3Abn.value ?? '';
    const legalName = toInteflowLegalName(b) ?? '';

    return {
      abn: abn,
      legalname: legalName
    };
  }

  onStep9DocEvent(files: UploadAzureFiles) {
    if(files && files.length > 0) {
      this.formControlStep9OtherSupportingDocuments.setValue(files)
    } else {
      this.formControlStep9OtherSupportingDocuments.setValue(null)
    }
  }

  applicationDefaultDocuments(includeOptions = false): DocumentTag[] {
    const applicantsThatAreGuarantor: IndividualGuarantor[] = this.step5OnwardsApplicantsThatAreGuarantor();
    const guarantors: IndividualGuarantor[] = individualGarantors(this.formControlStep5Guarantors.value);
    const names = [...applicantsThatAreGuarantor, ...guarantors]
      .map(requireDriverLicence => `${requireDriverLicence.firstName} ${requireDriverLicence.lastName}`);
    return this.defaultDocuments(
      'BusinessOverdraft',
      names,
      toInteflowLegalName(this.formControlStep1Business.value) ?? "",
      "",
      "",
      this.formControlStep2LoanAmount.value ?? 0,
      0,
      false,
      this.formControlStep3OrganisationType.value === EntityTypeTrustOption,
      this.formControlStep3OrganisationType.value === EntityTypePartnershipOption,
      includeOptions
    );
  }

  listUploadedDocuments() {
    if (this.applicationId) {
      this.subscriptions.push(
        this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
          (r: AzureStorageDocument[]) => {
            // includes ID documents (driver licence / passport) uploaded through the individual form
            const documents = r.filter(arg => arg.metadata);
            this.step9UploadedDocs = documents;
            this.applicationDocuments = documents;
          }
        )
      )
    }
  }

}
